let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("bRMot"), load("icOnU")]).then(() => parcelRequire('5ilBn'));